// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @actions
const checkStatusActions = require('../../actions/RACheckStatus');

class RAWrapperView extends React.Component {
    componentDidMount() {
        this.props.checkStatus();
    }

    render() {
        const { children } = this.props;
        return <div>{children}</div>;
    }
}

RAWrapperView.propTypes = {
    checkStatus: PropTypes.func.isRequired,
    children: PropTypes.any,
};

module.exports = connect(() => ({}), {
    checkStatus: checkStatusActions.checkStatus,
})(RAWrapperView);
